
import positionHroResumeCountStore from './moudules/positionHroResumeCountStore';
import defaultStore from './moudules/defaultStore';
import accountStore from './moudules/accountStore';

export default {
    positionHroResumeCountStore,
    defaultStore,
    accountStore,
}